import React, { useState } from "react"

export const myContext = React.createContext()

const Provider = props => {
  const [isDark, setTheme] = useState(true)

  React.useEffect(() => {
    if (
      typeof window !== `undefined` &&
      window.localStorage.getItem("darkMode") === "true"
    )
      setTheme(true)
    else setTheme(false)
  }, [])

  const changeColors = val => {
    if (typeof window !== `undefined`) {
      if (val) {
        setTheme(val)
        window.localStorage.setItem("darkMode", true)
        return
      }
      window.localStorage.setItem("darkMode", false)
      setTheme(val)
    }
  }

  return (
    <myContext.Provider
      value={{
        isDark,
        changeTheme: () => changeColors(!isDark),
      }}
    >
      {props.children}
    </myContext.Provider>
  )
}

export default ({ element }) => <Provider>{element}</Provider>
